import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = ['Clases listas para usar', 'Secuencias profesionales', 'Meditaciones guiadas', 'Pranayamas', 'Recursos imprimibles', 'Herramientas de gestión', 'Planificación anual', 'Acceso inmediato'];
export function TomoIncludes() {
  return <section className="py-24 lg:py-32 bg-transparent" data-id="element-211">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-213">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white text-ink-700 font-medium text-xs uppercase tracking-widest mb-6 border border-ink-100 shadow-sm" data-id="element-214">
            Todo incluido
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-900 mb-6 leading-tight tracking-tight" data-id="element-215">
            Todo lo que recibís{' '}
            <span className="text-brand-600 italic" data-id="element-216">en un solo lugar</span>
          </h2>
          <p className="text-lg text-ink-600 font-light" data-id="element-217">
            Un sistema completo. Sin archivos sueltos, sin buscar en mil
            carpetas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] p-8 md:p-14 shadow-sm border border-ink-100/50" data-id="element-218">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-6" data-id="element-219">
            {features.map((f, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="flex items-center gap-4 py-4 border-b border-ink-100/50 last:border-0 sm:[&:nth-last-child(2)]:border-0" data-id="element-220">
                <div className="w-8 h-8 rounded-full bg-brand-50 text-brand-700 flex items-center justify-center shrink-0" data-id="element-221">
                  <Check className="w-4 h-4" strokeWidth={2} data-id="element-222" />
                </div>
                <span className="font-medium text-ink-800 text-base lg:text-lg" data-id="element-223">
                  {f}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}